import React from 'react';
import usePRSchema from '../../../../../store/ReactQueries/general/documentTemplate/usePRSchema';
import useRFQSchema from '../../../../../store/ReactQueries/general/documentTemplate/useRFQSchema';
import useRFPSchema from '../../../../../store/ReactQueries/general/documentTemplate/useRFPSchema';
import Button from '@mui/joy/Button';
import { EditorState, Modifier } from 'draft-js';
import usePOSchema from '../../../../../store/ReactQueries/general/documentTemplate/usePOSchema';

const formatLabel = (text: string | undefined): string => {
    if (!text) return "";
    return text.replace(/([a-z])([A-Z])/g, "$1 $2");
};

interface Props {
    selectSchema: string;
    editorState: EditorState;
    onEditorStateChange: (state: EditorState) => void;
}

const SchemaInsertButton: React.FC<Props> = ({ selectSchema, editorState, onEditorStateChange }) => {
    const { data: pr } = usePRSchema();
    const { data: rfq } = useRFQSchema();
    const { data: rfp } = useRFPSchema();
    const { data: po } = usePOSchema();

    const getSchemaData = (): string[] => {
        switch (selectSchema) {
            case 'RFQ':
                return rfq ?? [];
            case 'RFP':
                return rfp ?? [];
            case 'PR':
                return pr ?? [];
            case 'PO':
                return po ?? [];
            default:
                return [];
        }
    };

    const insertText = (text: string) => {
        const contentState = editorState.getCurrentContent();
        const selection = editorState.getSelection();

        const insertedText = ` {{${text}}}`;
        const contentWithText = Modifier.insertText(contentState, selection, insertedText);

        // Selection covering the inserted text
        const startOffset = selection.getStartOffset();
        const endOffset = startOffset + insertedText.length;
        const boldSelection = selection.merge({
            anchorOffset: startOffset,
            focusOffset: endOffset,
        });

        // Apply BOLD style
        const contentWithStyle = Modifier.applyInlineStyle(contentWithText, boldSelection, 'BOLD');

        // Create a new selection at the end of inserted text
        const finalSelection = selection.merge({
            anchorOffset: endOffset,
            focusOffset: endOffset,
            isBackward: false,
        });

        // Push the updated content and set the selection to after the inserted text
        let newEditorState = EditorState.push(editorState, contentWithStyle, 'insert-characters');
        newEditorState = EditorState.forceSelection(newEditorState, finalSelection);

        // Explicitly remove the BOLD style from the editor state (so future typing is normal)
        newEditorState = EditorState.setInlineStyleOverride(newEditorState, newEditorState.getCurrentInlineStyle().remove('BOLD'));

        onEditorStateChange(newEditorState);
    };



    return (
        <div className="schema-button-container mt-1 mb-2">
            {getSchemaData().map((item, index) => (
                <Button
                    key={index}
                    size="sm"
                    variant="outlined"
                    sx={{
                        // color: 'black',
                        color: '#696CFF',
                        // borderColor: '#DEE2E6',
                        borderColor: '#696CFF',
                        '&:hover': {
                            backgroundColor: '#f0f0f0',
                            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                        },

                    }}
                    onClick={() => insertText(item)}
                >
                    {formatLabel(item)}
                </Button>
            ))}
        </div>
    );
};

export default SchemaInsertButton;
